const header = {
	notifications: {
		no_new: "Geen nieuwe notificaties",
		not_found: "Geen notificaties gevonden",
		title: "Notificaties",
		view_all: "Bekijk alle notificaties",
	},
	search: {
		no_results: "Geen resultaten gevonden...",
		placeholder: "Zoeken in de portal",
	},
	user_dropdown: {
		roles: {
			owner: "Eigenaar",
			sub_user: "Gebruiker",
		},
		tabs: {
			cancel_impersonate: "Account overname stoppen",
			my_account: "Persoonlijk",
			my_company: "Bedrijf",
			sign_out: "Uitloggen",
		},
	},
};

export default header;
